import {
    type MarkContactFormAsReadResponseType,
    type MarkContactFormAsReadRequestType
} from "./type";
import {
    request
} from "../request";

const markContactFormAsRead = async (
    params: MarkContactFormAsReadRequestType
): Promise<MarkContactFormAsReadResponseType> => {
    return await request<MarkContactFormAsReadResponseType>(`/request/markContactFormAsRead/${params.id}`, {
        method: "PUT"
    });
};
export default markContactFormAsRead;
